import Grid from '@mui/material/Unstable_Grid2'
import AccessManagementSection from './accessManagementSection'
import BookingManagementSection from './bookingManagementSection'
import BookingsOverviewSection from './bookingsOverviewSection'
import CreateBookingSection from './createBookingSection'
import FacilityManagementSection from './facilityManagementSection'
import IntroductionSection from './introductionSection'
import ReadyToGetStartedSection from './readyToGetStartedSection'
const FeaturesPage = () => {
  return (
    <Grid container justifyContent={'center'} textAlign={'center'} sx={{ overflowX: 'hidden' }}>
      <Grid xs={12} sm={12} md={12} mt={8} marginTop={'2rem'}>
        <IntroductionSection />
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <CreateBookingSection />
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <BookingsOverviewSection />
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <FacilityManagementSection />
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <BookingManagementSection />
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <AccessManagementSection />
      </Grid>
      <Grid xs={12} sm={12} md={12}>
        <ReadyToGetStartedSection />
      </Grid>
    </Grid>
  )
}

export default FeaturesPage
